import React from "react"

import Layout from "../components/global/Layout"
import Hero from "../components/block/Hero"
import HighlightFeature from "../components/block/HighlightFeature"
import SEO from "../components/global/SEO"
import Certs from "../components/block/Certs"

export default function AboutPage() {
  return (
    <div>
      <Layout>
        <SEO
          title="Userfy, the User Testing Consultancy"
          description="Our methodology delivers deep and comprehensive insights that will help you better understand your users, diagnose and remove UX issues and design an engaging and high-performing experience."
        />
        <Hero
          title="Hi, I’m Phil, welcome to my consultancy – Userfy"
          content="I’ve been working on the Internet, since the start of the Internet."
          copyWidth="320px"
        />
        <HighlightFeature
          content={
            <>
              <p>
                Thank you for visiting the Userfy website. If you would like to
                read about how Userfy came to be and my previous experience,
                here is a summary.
              </p>
              <h4>My Experience and Journey</h4>
              <ul>
                <li>
                  4 years in the Marketing Research team at Boots working on
                  qualitative and quantitative projects.
                </li>
                <li>
                  6 years in brand management and corporate strategic marketing
                  roles.
                </li>
                <li>
                  Co-founded (2004), built and sold (2015) North 51, a
                  multi-million-pound digital and software business.
                </li>
                <li>
                  Co-founded (2013) and sold (2015) The Insight Lab, a
                  specialist User Research consultancy.
                </li>
                <li>
                  Founded (2017) Userfy as a small, specialist consultancy to
                  help digital teams design better products.
                </li>
                <li>
                  Certified in Digital Psychology and Persuasion, trained in
                  Design Thinking by Ideo.
                </li>
              </ul>
              <p>
                Having worked in marketing research, strategic marketing and
                built and sold a digital business and a user research agency, I
                was looking for a next venture that, first and foremost, I
                really enjoyed. Userfy is a specialist consultancy, focused on
                designing, delivering and analysing, moderated, remote user
                testing. Our methodology delivers deep and comprehensive
                insights that will help you better understand your users,
                diagnose and remove UX issues and design an engaging and
                high-performing experience.
              </p>
              <p>
                I am supported by several very talented domain consultants.
                Please feel free to contact me any time if you would like to
                talk about how we might be able to help.
              </p>
            </>
          }
        />
        <Certs
          postContent="Feel free to get in touch for a completely no-obligation discussion about how we might be able to help."
          buttonText="Get in touch"
          buttonLink="/contact/"
          postCta={true}
        />
      </Layout>
    </div>
  )
}
